// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Arrow_wrapper__192xK","left":"Arrow_left__2F3nv","line":"Arrow_line__28GeZ","triangle":"Arrow_triangle__1qAQs"};